import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import SvgPin from '../../svg-pin';

const cache = {};

/**
 * Return data URL for pin SVG with given color.
 * Results are cached per color to avoid repeated rendering.
 * @param {string} color - CSS color for the pin
 * @returns {string} data URL for use as background-image, or empty string if no color
 */
export function getColoredPinDataUrl(color) {
    if (!color) return '';
    if (cache[color]) return cache[color];
    const svgString = renderToStaticMarkup(React.createElement(SvgPin, { color }));
    const dataUrl = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svgString)))}`;
    cache[color] = dataUrl;
    return dataUrl;
}

/**
 * Return a full CSS string for a colored pin background.
 * Suitable for passing directly as inline style to marker HTML.
 * @param {string} color - CSS color for the pin
 * @returns {string} CSS string or empty string if no color
 */
export function getColoredPinCssString(color) {
    const dataUrl = getColoredPinDataUrl(color);
    if (!dataUrl) return '';
    return `background-image:url("${dataUrl}");background-size:100% 100%;background-repeat:no-repeat;background-position:center bottom`;
}
